import { memo } from "react";
import { classNames } from "shared/lib/classNames/classNames";
import cls from "./SociometryProgress.module.scss";

interface SociometryProgressProps {
    currentQuestion: number;
    totalQuestions: number;
    className?: string;
}

export const SociometryProgress = memo((props: SociometryProgressProps) => {
    const { currentQuestion, totalQuestions, className } = props;

    const progressPercent = ((currentQuestion + 1) / totalQuestions) * 100;

    return (
        <div className={classNames(cls.sociometryProgress, {}, [className])}>
            <div className={cls.progressBar}>
                <div className={cls.progressFill} style={{ width: `${progressPercent}%` }} />
            </div>
        </div>
    );
});

SociometryProgress.displayName = "SociometryProgress";
